
import template from './AlertPrompt.html';

class AlertPromptVM
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.title = ko.observable(dialog.bindings.title || '');
		this.message = ko.observable(dialog.bindings.message || '');
		this.type_class = ko.observable(dialog.bindings.class || '');
		this.icon = ko.observable(dialog.bindings.icon || '');
		this.fields = ko.observable(dialog.bindings.fields || [{name:'prompt', type:'text', label:''}]);
		this.inputs = ko.observable({});
		this.cancel_text = ko.observable(dialog.bindings.cancel_text || 'Cancel');
		this.accept_text = ko.observable(dialog.bindings.accept_text || 'Submit');
		this.hide_labels = ko.observable(dialog.bindings.hide_labels || false);
	}

	on_enter_key_up (data, event)
	{
		if (event.keyCode === 13)
			this.submit();

		return true;
	}

	submit ()
	{
		this.dialog.close(ko.mapping.toJS(this).inputs);
	}

	cancel ()
	{
		this.dialog.close(false);
	}
}

class AlertPromptDialog
{
	constructor(bindings, element)
	{
		this.bindings = bindings || {};
		this.viewModel = new AlertPromptVM(this);
		this.name = 'AlertPromptDialog';
	}
}

export default {
	name: 'AlertPrompt',
	dialog_class: AlertPromptDialog,
	provider: 'ps',
	template: template
}
